//@ts-nocheck
import React, { useEffect } from 'react';
import styled from "styled-components";
import * as d3 from 'd3';
import { gray, blue, green, orange, other, deleteECRReportImage, exportECRChart, filterECRHeading_AndComparison, compareMeasure, createStackedChart_NoComparison, createStackedChart_Comparison } from "./elements/helpers";
import { Heading3, ReportText } from '../../Common/SharedStyledComponents';

const JournalRankChart = ({
    journalRankData,
    journalRankData_2,
    parentWidth,
    EarlyCareerReportState,
    report_display_id,
    currentDateTime,
    university,
    start_year,
    end_year,
    vintage
}) => {
    useEffect(() => {
        d3.select("#JournalRankChart svg").remove();
        d3.select("#JournalRankChart .ecr_tooltip").remove();
        deleteECRReportImage("journal-rank-chart.png", currentDateTime, report_display_id, vintage);

        //console.log(journalRankData);
        //console.log(journalRankData_2);
        const compare_measure = compareMeasure(EarlyCareerReportState.EarlyCareerReportFilterSavedValues);

        if ((compare_measure == 0 && journalRankData && journalRankData.length > 0) ||
            (compare_measure > 0 && journalRankData && journalRankData_2 && journalRankData.length > 0 && journalRankData_2.length > 0)) {
            exportECRChart("#JournalRankChart", "journal-rank-chart.png", EarlyCareerReportState, report_display_id, currentDateTime, "no", vintage)
        }
    }, [journalRankData, journalRankData_2, parentWidth])
    //console.log(EarlyCareerReportState.EarlyCareerReportFilterSavedValues);
    const subHeading = filterECRHeading_AndComparison(EarlyCareerReportState.EarlyCareerReportFilterSavedValues, EarlyCareerReportState.Suborgs);
    const compare_measure = compareMeasure(EarlyCareerReportState.EarlyCareerReportFilterSavedValues);

    if (compare_measure > 0) {
        //need both awardCount and journalRankData_2 to have at least one value per year

        const years = ['1', '2', '3', '4', '5', '6', '7', '8'];
        const filtered1 = journalRankData?.filter(function (item) {
            return years.includes(item.t_emp);
        })
        const filtered2 = journalRankData_2?.filter(function (item) {
            return years.includes(item.t_emp);
        })
    }
    //console.log(compare_measure);

    const heading1 = (compare_measure == 1) ? "Early Career Award" : "Male";
    const heading2 = (compare_measure == 1) ? "No Early Career Award" : "Female";
    return (
        <div className="ChartComponent">
            <div id="JournalRankChart_ForExport">
                <Heading3 bold italic>Top Journals listing, {university} Faculty</Heading3>
                <Heading3 italic>{subHeading}</Heading3>
                <div id="JournalRankChart">
                {(compare_measure > 0) ?
                    <div className="row">
                        <div className="column">
                            <h4 className="heading4_space">{heading1}</h4>
                            <ul className="ul_compare">
                                {journalRankData && journalRankData.map(d => (
                                    <li>{d.journal} ({d.pct_people}%)</li>
                                ))} 
                            </ul>
                        </div>
                        <div className="column">
                            <h4 className="heading4_space">{heading2}</h4>
                            <ul className="ul_compare">
                                {journalRankData_2 && journalRankData_2.map(d => (
                                    <li>{d.journal} ({d.pct_people}%)</li>
                                ))}                        
                            </ul>
                        </div>
                        </div> :
                    <div>
                        <ul className="ul_no_compare">
                            {journalRankData && journalRankData.map(d => (
                                <li>{d.journal} ({d.pct_people}%)</li>
                            ))}
                        </ul>
                    </div>
                }
                </div>
                {(journalRankData?.length == 0 || (compare_measure > 0 && (journalRankData?.length == 0 || journalRankData_2?.length == 0))) && <p className="no_data_text">Due to the small number of results and the potential for disclosure of personal information, this chart cannot be displayed. Please select a larger group.</p>}
                <ReportText>
                    This is a list of journals in which the most individual faculty members on sponsored projects published articles. The proportions are based on number of individual authors, not the number of articles published. "Data Year" refers to the number of years a cohort of faculty members has appeared in the IRIS-UMETRICS dataset of researchers paid on sponsored grants. Data from {start_year} to {end_year} were used to build these cohorts.
                </ReportText>
                <ReportText>
                    * Journals marked with an asterisk are high-impact publications, with an impact factor of 10 or higher.
                </ReportText>
                {/*(compare_measure > 0) &&
                    (filtered1?.length < 8 || filtered2?.length < 8) &&
                    <p>Note: Insufficient data</p>
                */}
            </div>
            <a className="export" onClick={() => exportECRChart("#JournalRankChart_ForExport", "journal-rank-chart.png", EarlyCareerReportState, report_display_id, currentDateTime, "yes", vintage)}><i className="fa fas fa-download ecr_export"></i>Export Chart</a>
        </div>
    );
}

/**
 * Styled div to shrink graph titles
 * */
export const TitleDiv = styled.div`
    width: 75%;
    margin-inline: auto;
`;

export default JournalRankChart;